const PHOTOS_PAGE_EN = {
  addMore: 'Add more',
  addMorePhotos: 'Add More Photos',
  allPhotosUploadedSuccessfully: 'All photos were uploaded successfully',
  addProgressPhotos: 'Add Progress Photos',
  allItTakesIsTwoMinutes: 'All it takes is 2 minutes. This allows your dermatologist to assess your needs.',
  anImageOfYourPhotoIdIsRequired: 'A photo ID is required by law in your state to prescribe medication.',
  continueWithoutUploading: 'Continue without uploading >',
  noWebcamDetected:
    'No camera detected or access was not allowed. Upload photos instead or try completing your visit from your phone.',
  capture: 'Capture',
  clearlyShowsPhotoAndText: 'Clearly shows photo and text',
  clickToUploadOrDrag: 'Click here to upload photos or drag and drop photos here.',
  close: 'Close',
  confirm: 'confirm',
  confirmPhotoId: 'Confirm Photo ID',
  done: 'Done',
  driversLicense: "Driver's License",
  driversLicenseOrGovId: "Driver's License or Gov't ID",
  goToMyOrders: 'Go to My Orders',
  hairLossPhotos: 'Hair Loss Photos',
  idPhotoChecklist: 'ID Photo Checklist:',
  isNotEditedFilteredBlurryOrDark: 'Is not edited, filtered, blurry, or dark',
  lastStep: 'Last Step',
  identification: 'Identification',
  lastStepUploadPhotoId: 'Last Step: Upload Photo ID',
  noDuplicates: 'Cannot upload duplicate photos',
  onlyOneLicense: 'You can only upload 1 picture of a government issued ID (drivers license)',
  orderComplete: 'Order Complete',
  pleaseGrantPermissionToAccessYourWebcam: 'Please grant permission to access your webcam.',
  pleaseUploadAllRequiredPhotos: 'Please upload all required photos',
  pleaseUploadHairLossPhotos: 'Please upload pictures of your hair loss. (Multiple photos)',
  pleaseUploadLicense: 'Please upload a photo of your government issued ID. (1 photo of the front)',
  pleaseUploadId: 'Please upload a picture of a government issued ID (drivers license). (1 photo)',
  pleaseUploadPhotosForDoctor: 'Please upload these photos for the doctor.',
  photosNotUploaded: 'Photos not uploaded. Please refresh the page and try again or try other photos.',
  photosPage: 'Photos Page',
  photoSuccessfullyUploaded: 'Photo successfully uploaded',
  recapture: 'Recapture',
  select: 'Select',
  send: 'Send',
  cancel: 'Cancel',
  reviewAndConfirmId: 'Review & Confirm ID',
  showsTheEntireFrontOfYourId: 'Shows the entire front of your ID',
  somethingWentWrong: 'Something went wrong. Your photos were not submitted. Please text us with your photos.',
  takePhoto: 'Take Photo',
  toSelectExistingPhotos: 'to select existing photos.',
  toUseCameraOr: 'to use camera or',
  thankYouForYourPurchase: 'Thank you for your purchase.',
  theMorePhotosYouProvide: 'The more photos you provide, the better your dermatologist can support you.',
  trackYourProgress: 'Track Your Progress',
  tryAgain: 'Try again',
  upload: 'Upload',
  uploadFile: 'Upload file',
  uploadMonthlyPhotos: 'Upload monthly photos to track your progress and see your results.',
  uploadMorePhotos: 'Upload More Photos',
  uploadPhotos: 'Upload Photos',
  uploadYourPhotos: 'Upload Your Photos',
  uploadYourPhotosToGetYourOrder: 'Upload Your Photos To Get Your Order',
  wantToAddMorePhotos: 'Want to Add More Photos?',
  yourDoctorWillNowReviewYourInformation: 'Your doctor will now review your information.',
  youreNotDoneYet: "You're not done yet!",
  yourPhotos: 'Your Photos',
  yourPhotosAreLoading: 'Your Photos Are Loading',
  yourPhotosHaveBeenSuccessfullyUploaded: 'Your photos have been successfully uploaded.',
};

export default PHOTOS_PAGE_EN;
